import type { CSSProperties, ReactNode } from "react";
import CaretExpander from "./inspector/CaretExpander";
import { SectionInlineTitle } from "./inspector/InspectorComponents";
import inspectorStyles from "./inspector/InspectorComponents.module.scss";

export interface CollapsibleSectionHeaderProps {
  header: ReactNode;
  expanded: boolean;
  setExpanded: (val: boolean) => void;
  topBorder?: boolean;
  style?: CSSProperties;
}

export const CollapsibleSectionHeader = ({
  header,
  expanded,
  setExpanded,
  topBorder = true,
  style: headerStyle,
}: CollapsibleSectionHeaderProps) => {
  return (
    <div
      className={inspectorStyles.pumpFlexRow}
      style={{
        justifyContent: "space-between",
        cursor: "pointer",
        boxSizing: "border-box",
        borderTop: topBorder ? "1px solid #dedede" : "0px solid black",
        marginTop: "4px",
        paddingLeft: 4,
        paddingRight: 4,
        width: "100%",
        ...headerStyle,
      }}
      onClick={() => setExpanded(!expanded)}
    >
      <CaretExpander isExpanded={expanded} size={7} />
      {header instanceof Object ? (
        <div style={{ width: "100%" }}>{header}</div>
      ) : (
        <SectionInlineTitle title={header as string} />
      )}
    </div>
  );
};
